import { useSession } from '../store/session';
import { useSettings, type TimeFormat } from '../store/settings';

/** true for a 12-hour clock, false for 24 hours, undefined to let the locale decide. */
export function resolveHour12(user: TimeFormat, admin: TimeFormat): boolean | undefined {
  const chosen = user !== 'auto' ? user : admin;
  return chosen === '12h' ? true : chosen === '24h' ? false : undefined;
}

export function currentHour12(): boolean | undefined {
  return resolveHour12(useSettings.getState().timeFormat, useSession.getState().defaults.timeFormat);
}

export function useHour12(): boolean | undefined {
  const user = useSettings((s) => s.timeFormat);
  const admin = useSession((s) => s.defaults.timeFormat);
  return resolveHour12(user, admin);
}
